export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 flex items-center overflow-hidden" style={{ minHeight: '70vh' }}>
      {/* Immagine di sfondo a piena copertura */}
      <img
        src="https://public.readdy.ai/ai/img_res/edited_687eab1af346d2e543e22f5f29d58d64_832b2cb8.jpg"
        alt="hero background"
        className="absolute inset-0 w-full h-full"
        style={{
          objectFit: 'cover',
          objectPosition: '70% 10%',
        }}
      />

      {/* Overlay scuro per leggibilità */}
      <div className="absolute inset-0 bg-black/45" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-8 w-full">
        <div className="max-w-2xl">
          <h1 className="text-4xl lg:text-[52px] font-bold text-white leading-tight">
            Independent Advisory in Carbon &amp; Precious Metals Markets
          </h1>
          
          <p className="mt-6 text-[17px] text-white/80 leading-relaxed break-words">
            Strategic intelligence, partner introductions and execution support across Asia-Pacific
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-[#B11226] text-white text-[15px] font-semibold px-10 py-[18px] rounded-full hover:bg-[#8F0E1E] transition-colors duration-200 whitespace-nowrap"
            >
              Request a Call
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
